<template>
  <div id="ptz" class="ptz">
    <v-progress-circular indeterminate class="progress-circular--center" color="#009999" width="10" size="150" v-show="!isPtzArrived"></v-progress-circular>
  </div>
</template>

<script>
export default {
  data() {
    return {
      connectionId: null,
      isPtzArrived: false
    }
  },
  created() {
  },
  mounted() {
    window.addEventListener('resize', this.resizePtz)
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.resizePtz)
  },
  methods: {
    setLiveStreamEventCallback(liveStreaming) {
      let self = this
      liveStreaming.on('ptz_start', function($video, connection_id, mediaStreamTrack, stream) {
        self.startPtz($video, connection_id, mediaStreamTrack, stream)
      })

      liveStreaming.on('ptz_stop', function() {
        self.stopPtz()
      })
    },
    startPtz($video, connection_id, mediaStreamTrack, stream) {
      this.isPtzArrived = true
      this.connectionId = connection_id
      let $ptzDiv = document.getElementById('ptz')
      $ptzDiv.appendChild($video);
      $video.zIndex = 1000;
      $video.style.position = 'absolute'

      if ($video.srcObject) {
        $video.srcObject.addTrack(mediaStreamTrack);
      } else {
        $video.srcObject = stream;
      }
      let isVideoPlaying = ($video.currentTime > 0 && !$video.paused && !$video.ended && $video.readyState > $video.HAVE_CURRENT_DATA)
      if (!isVideoPlaying) {
          $video.play()
      }
      this.$emit('addPtz', { connectionId : connection_id })
      this.resizePtz()
    },
    stopPtz() {
      this.destroy()
      this.$emit('destroyPtz')
    },
    resizePtz() {
      // 画面サイズに応じて表示エリアの背景の大きさを変更
      let $ptzDiv = document.getElementById('ptz')
      let $video = document.getElementById(this.connectionId)
      let height = window.innerHeight - document.getElementsByTagName('header')[0].clientHeight
      if (height <500) {
        $ptzDiv.style.height = '500px'
      }
      else {
        $ptzDiv.style.height = `${height}px`
      }

      let ptzDivWidth = window.innerWidth
      let ptzDivHeight = parseInt($ptzDiv.style.height)

      // アスペクト比 4:3を維持したまま、配信映像表示エリア内に表示が収まるようサイズを修正する
      if ($video != null) {
        if (ptzDivWidth * 3 / 4 <= ptzDivHeight) {
          $video.style.height = `${ptzDivWidth * 3 / 4}px`
          $video.style.width = `${ptzDivWidth}px`
        }
        else if (ptzDivWidth * 3 / 4 > ptzDivHeight) {
          $video.style.height =`${ptzDivHeight}px`
          $video.style.width = `${ptzDivHeight * 4 / 3}px`
        }
        else {
            // nothing
        }
        $video.style.marginLeft = `${(ptzDivWidth - parseInt($video.style.width)) / 2}px`
        $video.style.marginTop = `${(ptzDivHeight - parseInt($video.style.height)) / 2}px`

        this.$emit('resizePtz')
      }
    } ,
    reconnect() {
      this.destroy()
    },
    destroy() {
      if ($video != null) {
        $video.pause()
      }
      let $ptzDiv = document.getElementById('ptz')
      let $video = document.getElementById(this.connectionId)
      if ($ptzDiv != null && $video != null && $ptzDiv.childElementCount > 0) {
        $ptzDiv.removeChild($video)
      }
      this.connectionId = null
      this.isPtzArrived = false
    }
  },
}
</script>

<style scoped>
.progress-circular--center {
  margin-top: 18%;
  margin-left: 50%;
  transform: translateX(-50%);
}
.ptz {
  position: relative;
  width: inherit;
  height: inherit;
  top: 0px;
  left: 0px;
  background-color: #000000;
}
.ptz-home-button{
  width: 175px;
  height: 64px !important;
  padding: 0 16px;
  background: #009999 0% 0% no-repeat padding-box;
  opacity: 1;
  font: normal normal bold 24px/32px Segoe UI;
  letter-spacing: 0px;
}
.ptz-home-button--layout {
  position: absolute;
  bottom: 10px;
  right: 5%;
}
</style>